// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"b08e1e8ffa08980da16a","715":"c83796b757b42bfaf1fb"}[chunkId] + ".js";
};